import router from '@/router';
import axiosRetry from 'axios-retry';

const axiosDefaultConfig = {
    baseURL: '/api/'
};

export default (config = axiosDefaultConfig, intercept = true) => {
    let instance = window.axios.create({
        ...config
    });
    axiosRetry(instance, { retries: 2, retryDelay: axiosRetry.exponentialDelay });

    // Should we intercept unauthorized and similar errors or not?
    if (intercept) {
        import('@/store/AuthPinia').then((pinia) => {
            const authStore = pinia.useAuthStore();
            instance.interceptors.response.use(
                function (response) {
                    return response;
                },
                async function (error) {
                    if ([401, 419, 302].includes(error.response.status)) {
                        await authStore.resetCurrentUser();

                        // Define route object to use with vue router
                        let routeObject = { name: "Login" };

                        // Only include query search when there's one
                        if (window.location.search != '') {
                            routeObject.query = urlQueryStringToObject();
                        }

                        // Set route object
                        let redirectTo = router.resolve(routeObject);

                        // Try to hard redirect and refresh the APP
                        if (redirectTo?.fullPath) {
                            window.location.href = '/';
                            return;
                        }

                        // Couldn't resolve route to do hard redirection for some reason, redirect using vue router
                        router.replace(routeObject)

                        return;
                    }
                    return Promise.reject(error);
                }
            );
        }).catch((err) => {
            console.log(err);
        });
    }
    return instance;
}

const urlQueryStringToObject = function () {
    var pairs = window.location.search.substring(1).split("&"),
        obj = {},
        pair,
        i;

    for (i in pairs) {
        if (pairs[i] === "") continue;

        pair = pairs[i].split("=");
        obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    return obj;
}
